import assistantText from '../../assets/text/text.json';
import { push, goBack } from 'connected-react-router';

export const SET_TEXT_TO_SPEAK = 'SET_TEXT_TO_SPEAK';
export const setTextToSpeak = (text: string) => {
  return {
    type: SET_TEXT_TO_SPEAK,
    text
  }
}

export const FINISHED_SPEAKING = 'FINISHED_SPEAKING';
export const finishSpeaking = () => {
  return {
    type: FINISHED_SPEAKING,
  }
}

export const IS_PLAYING = 'IS_PLAYING';
export const isPlaying = (isPlaying: boolean) => {
  return {
    type: IS_PLAYING,
    isPlaying
  }
}

export const SET_DATA = 'SET_DATA';
export const setData = (data: any) => {
  return {
    type: SET_DATA,
    data
  }
}

export const ALREADY_PLAYED = 'ALREADY_PLAYED';
export const alreadyPlayed = (status: boolean) => {
  return {
    type: ALREADY_PLAYED,
    status
  }
}

let result: string[] = [];

const traverseJsonObject = (obj: any) => {
  result = [];
  for (var o in obj) {
      if (typeof obj[o] == "object") {
        traverseJsonObject(obj[o]);
      } else {
          result.push(obj[o]);
      }
  }
}



export const pushAndStop = (page: string) => {
  return (dispatch: any) => {
    dispatch(setData(null));
    dispatch(push(page));
  }
}

export const backAndStop = () => {
  return (dispatch: any) => {
    dispatch(setData(null));
    dispatch(goBack());
  }
}

export const loadContentForPage = (page: string) => {
  return (dispatch: any) => {
    const text: any = assistantText;
    traverseJsonObject(text[page]);
    console.log(result);
  //  dispatch(loadText(result));
  }
}

export const LOAD_TEXT = 'LOAD_TEXT';
export const loadText = (text: any) => {
  console.log(text);
  return {
    type: LOAD_TEXT,
    text
  }
}

export const SET_CURRENT_LINE = 'SET_CURRENT_LINE';
export const setCurrentLine = (currentLine: any) => {
  return {
    type: SET_CURRENT_LINE,
    currentLine
  }
}